import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { BasicAuthInterceptor } from './_interceptors/basicauth.interceptor';

import { AuthGuard } from './_guard/auth.guard';
import { AuthChangePasswordGuard } from './_guard/auth-change-password.guard';

import { setAppInjector } from './_helpers/app-injector';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { CambioPasswordComponent } from './components/cambio-password/cambio-password.component';

import { ImpostazioniUtenteComponent } from './components/impostazioni-utente/impostazioni-utente.component';
import { ExaModule } from './exa/exa.module';

import { AppRoutingModule } from './app-routing.module';

import { ConfirmationPopoverModule } from 'angular-confirmation-popover';

import { FileService } from './_services/file.service';

import { DocumentoService } from './_services/documento.service';

import { AuthenticationService } from './_services/authentication.service';
import { UtenteService } from './_services/utente.service';
import { ListRetrieverService } from './_services/list-retriever.service';

import { RoutingParameterService } from './_services/routing-parameters.service';
import { HomepageComponent } from './components/homepage/homepage.component';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { WaitingComponent } from './components/waiting/waiting.component';
import { ProduttoreModule } from './components/produttore/produttore.module';
import { AuthProduttoreGuard } from './_guard/auth-produttore.guard';
import { AuthSmistatoreGuard } from './_guard/auth-smistatore.guard';
import { AuthAmministratoreGuard } from './_guard/auth-amministratore.guard';
import { LottoProduzioneService } from './_services/lotto-produzione.service';
import { LottoSpedizioneService } from './_services/lotto-spedizione.service';
import { StatoConsegnaService } from './_services/stato-consegna.service';
import { BorsellinoProdottiService } from './_services/borsellino-prodotti.service';
import { AuthRichiedenteGuard } from './_guard/auth-richiedente.guard';
import { ParametroService } from './_services/parametro.service';
import { AuthHomepageGuard } from './_guard/auth-homepage.guard';
import { ParametriServizioService } from './_services/parametri-servizio.service';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    WaitingComponent,

    HomepageComponent,

    ImpostazioniUtenteComponent,
    CambioPasswordComponent,

    LoginComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,

    ExaModule,
    ConfirmationPopoverModule.forRoot(ExaModule.CONFIRMAPOPUP_OPTIONS),

  ],
  providers: [
    AuthGuard,
    AuthChangePasswordGuard,
    AuthHomepageGuard,

    AuthAmministratoreGuard,
    AuthProduttoreGuard,
    AuthSmistatoreGuard,
    AuthRichiedenteGuard,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: BasicAuthInterceptor,
      multi: true
    },

    LottoProduzioneService,
    LottoSpedizioneService,
    StatoConsegnaService,
    BorsellinoProdottiService,
    ParametroService,
    ParametriServizioService,

    FileService,

    AuthenticationService,

    DocumentoService,

    UtenteService,

    RoutingParameterService,
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    setAppInjector(injector);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts